import { atom } from "jotai";

export const storageSlotAtoms = atom({ awLoading: true });
